import { Trans } from "@lingui/macro";
import Image from "next/image";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { Button } from "~/guidelines/Button";
import { Stack } from "~/guidelines/Flex";
import mediaQueries from "~/guidelines/Theme/mediaQueries";
import { body1 } from "~/guidelines/Typography";
import Send from "../_assets/specifications/send.svg";
import TeamDesktop from "./TeamDesktop";
import TeamMobile from "./TeamMobile";

const Container = styled(Stack)`
  align-items: center;
  max-width: 1200px;
  margin: 32px 16px;
  ${mediaQueries.lg()} {
    width: 100%;
    margin: 80px auto;
  }
`;

const ContentWrapper = styled(Stack)`
  width: 100%;
  padding: 0px;
  gap: 30px;
  border: none;
  align-items: center;

  @media (min-width: 900px) {
    border: 10px solid ${({ theme }) => theme.color.text.lightFirst};
    padding: 80px;
    gap: initial;
  }
`;

const InvitationText = styled.p`
  ${body1}
  color: ${({ theme }) => theme.color.text.lightFirst};
  text-align: center;
  max-width: 600px;
  line-height: 1.6;
  margin: 10px auto;

  @media (min-width: 768px) {
    margin: 87px auto;
  }
`;

const FlexCenter = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Team = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1200);
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Container>
      <ContentWrapper>
        {isMobile ? <TeamMobile /> : <TeamDesktop />}

        <InvitationText>
          <Trans>
            Dear investors, dear hoteliers, let&apos;s meet to reinvent the
            hotel industry in our regions together.
          </Trans>
        </InvitationText>

        <Button
          size="large"
          href="https://encore-mieux.typeform.com/to/p5ssSaDE?typeform-source=encore-mieux.com"
        >
          <FlexCenter>
            <Image src={Send} alt="send" />
            <Trans>Get in touch</Trans>
          </FlexCenter>
        </Button>
      </ContentWrapper>
    </Container>
  );
};

export default Team;
